import React from 'react';

export default function HeaderTitle({ children = ""}) {

    return <div style={{fontSize: "23px"}}>
            {children}
        </div>
}